import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { TimelineManager } from "./NossaHistoria/TimelineManager";
import { TeamManager } from "./NossaHistoria/TeamManager";
import { ContentManager } from "./NossaHistoria/ContentManager";

export function NossaHistoriaManager() {
  return (
    <Tabs defaultValue="timeline" className="w-full">
      <TabsList className="grid w-full grid-cols-3">
        <TabsTrigger value="timeline">Timeline</TabsTrigger>
        <TabsTrigger value="team">Equipe</TabsTrigger>
        <TabsTrigger value="content">Conteúdo</TabsTrigger>
      </TabsList>

      <TabsContent value="timeline" className="mt-6">
        <TimelineManager />
      </TabsContent>

      <TabsContent value="team" className="mt-6">
        <TeamManager />
      </TabsContent>

      <TabsContent value="content" className="mt-6">
        <ContentManager />
      </TabsContent>
    </Tabs>
  );
}